let basePath = 'http://localhost:4000';
let artefactPath = '';

export const baseUrl = {
  get: () => {
    return basePath;
  },
  set: url => basePath = url
};

export const artifactUrl = {
  get: () => {
    return artefactPath;
  },
  set: url => artefactPath = url
};



// WEBPACK FOOTER //
// ./actions/config.js